import { IconButton } from "@material-ui/core";
import React, { MouseEventHandler } from "react";
import "../buttons.scss";
import { Close } from "@material-ui/icons";

type Props = {
    onClose: MouseEventHandler;
};

const ButtonExitModal = ({ onClose }: Props): React.ReactElement => {
    return (
        <IconButton id="BtnExitModal" className="exit-modal-btn" onClick={onClose}>
            <Close className="close-modal-btn" />
        </IconButton>
    );
};

export default ButtonExitModal;
